export default __webpack_public_path__ + "static/homepage-starter-contentful-951619a9219e633d333cbb4ff45818fa.png";